// components/LoadingScreen.jsx
import React from "react";
import "./LoadingScreen.css";
import { ReactComponent as AprendoleIcon } from "../../icons/AprendoleIcon5.svg";

export default function LoadingScreen({ debugLabel }) {
  return (
    <div className="loading-screen">
      <AprendoleIcon className="logo spin" />
      <div className="dots">•••</div>

      {/*
      DEBUG:
      {debugLabel}
      */}
    </div>
  );
}
